import styled from "styled-components";
import {Button} from "../../../../basic-ui-components/button/base/button.component";

export const AdvancedGamesFilterButtonBox = styled(Button)`
    min-width: 140px;
`